var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"mb-12",attrs:{"cols":"12","md":"4"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"400","type":"card"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }